import { Button, Grid, makeStyles, Typography } from '@material-ui/core'
import { FC, useState } from 'react'
import { Form } from 'react-final-form'
import MyTextfield from '../../../control/textfield/textfield'
import useTranslate from '../../../i18n/useTranslate'
import MyDatePicker from '../../../control/datepicker/datepicker'
import { ReviewerSearchForm } from '../../../services/um/useSearchReviewer'
import Select from '../../../control/select/select'
import { FormApi } from 'final-form'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import moment from 'moment'
import useProjectType from '../../../services/um/lookups/useProjectType'
interface PanelProps {
    onSubmit: (values: ReviewerSearchForm) => void
    initialSearch: ReviewerSearchForm
    onReset: (form: any) => void
}
const Panel: FC<PanelProps> = ({ onSubmit, initialSearch, onReset }) => {
    const classes = useStyles()
    const translate = useTranslate()
    const { projectT } = useProjectType()
    const [endDate, setEndDate] = useState<string | null>(moment(new Date()).format('YYYY-MM-DD'))
    let defaultProjectType = initialSearch.projectType ? [initialSearch.projectType] : undefined

    const handleStartDateChange = (form: FormApi<ReviewerSearchForm>, value: string | null) => {
        if (value && endDate) {
            let isStartAfter = moment(value).isAfter(endDate)
            if (isStartAfter) {
                form.change('endDate', new Date(value))
            }
        }
    }

    const handleEndDateChange = (value: string | null) => {
        setEndDate(value)
    }

    return (
        <Grid className={classes.root}>
            <Form onSubmit={onSubmit} initialValues={initialSearch}>
                {({ handleSubmit, form, values }) => {
                    return (
                        <Grid container spacing={2} className={classes.container}>
                            <Grid item xs={12} sm={6}>
                                <MyTextfield
                                    name="keyword"
                                    materialInputProps={{
                                        label: `${translate.get('LABEL.SEARCH_BY_KEYWORD')}`,
                                        disabled: false,
                                        placeholder: `${translate.get('UM.REVIEWER.SEARCH_BY_KEYWORD')}`,
                                        size: 'small',
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Select
                                    name="projectType"
                                    option={[
                                        {
                                            value: null,
                                            label: translate.get('LABEL.NOT_SPECIFIC'),
                                        },
                                        ...projectT,
                                    ]}
                                    label={translate.get('LABEL.PROJECT_TYPE')}
                                    placeholder={translate.get('LABEL.PROJECT_TYPE')}
                                    size="small"
                                    defaultValue={defaultProjectType}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MyDatePicker
                                    name="startDate"
                                    label={translate.get('UM.REVIEWER.START_DATE')}
                                    onChangeValue={(val: string) => handleStartDateChange(form, val)}
                                    icon={<CalendarTodayIcon color="disabled" />}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MyDatePicker
                                    name="endDate"
                                    label={translate.get('UM.REVIEWER.END_DATE')}
                                    minDate={new Date(values.startDate)}
                                    onChangeValue={(val: string) => handleEndDateChange(val)}
                                    icon={<CalendarTodayIcon color="disabled" />}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justify="flex-end" spacing={2}>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="default"
                                            onClick={() => {
                                                form.reset()
                                                onReset(form)
                                            }}
                                        >
                                            {translate.get('BUTTON.RESET')}
                                        </Button>
                                    </Grid>

                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                        >
                                            {translate.get('BUTTON.SEARCH')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                }}
            </Form>
        </Grid>
    )
}

export default Panel

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    container: {
        padding: '1.7rem',
    },
    reset: {
        textDecoration: 'underline',
        cursor: 'pointer',
        padding: '0px 1.5rem',
        alignSelf: 'center',
    },
}))
